if (process.env.NODE_ENV === 'production' && process.env.chrome41 === true) {
  require('@babel/polyfill');
  require('whatwg-fetch');
}
import {
  AnyAction,
} from 'redux';
import getConfiguredStore from './getConfiguredWorkerStore';

const store = getConfiguredStore();

addEventListener('message', (e: MessageEvent) => {
  const data: AnyAction = JSON.parse(e.data);
  store.dispatch(data);
});
